import type { MusicGenre, MusicMood } from './types';

export type DriveState = 'IDLE' | 'CRUISING' | 'EXCITED' | 'SCARED' | 'LATE_NIGHT';

const MOOD_TABLE: Record<MusicGenre, Partial<Record<DriveState, MusicMood>>> = {
    electronic: { IDLE: 'focused', CRUISING: 'hyped', EXCITED: 'hyped', LATE_NIGHT: 'late-night' },
    hiphop: { IDLE: 'focused', CRUISING: 'hyped', EXCITED: 'hyped' },
    rock: { IDLE: 'focused', CRUISING: 'hyped', EXCITED: 'hyped' },
    pop: { IDLE: 'focused', CRUISING: 'hyped', EXCITED: 'hyped' },
    classical: { IDLE: 'calm', CRUISING: 'calm', SCARED: 'calm', LATE_NIGHT: 'late-night' },
    ambient: { IDLE: 'calm', CRUISING: 'calm', SCARED: 'calm', LATE_NIGHT: 'late-night' },
    world: { IDLE: 'scenic', CRUISING: 'scenic', LATE_NIGHT: 'scenic' },
    lofi: { IDLE: 'calm', CRUISING: 'calm', SCARED: 'calm', LATE_NIGHT: 'late-night' },
    folk: { IDLE: 'scenic', CRUISING: 'scenic', LATE_NIGHT: 'scenic' },
    jazz: { IDLE: 'focused', CRUISING: 'focused', LATE_NIGHT: 'late-night' },
};

export function deriveMood(genre: MusicGenre, driveState: DriveState): MusicMood | null {
    return MOOD_TABLE[genre]?.[driveState] ?? null;
}
